import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Loader,
  Container,
  Content,
  Checkbox,
  Modal,
} from "rsuite";
import { ChartServices } from "../../../core/services/ChartServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./Charts.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { displayDateField, displayField } from "../../../utils/helpers";

const ViewProfileModal = (props: any) => {
  const { t } = useTranslation();
  const chartId = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const [loader, setLoader] = useState(false);
  const [chartInfo, setChartInfo] = useState<any>({});
  const [address, setAddress] = useState<any>({});
  async function getViewChartDetail(id: number) {
    try {
      setLoader(true);
      const res = await ChartServices.viewChart(id);
      setLoader(false);
      if (res && res.data && res.data.data) {
        setChartInfo({ ...res.data.data });
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    getViewChartDetail(chartId);
  }, []);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={props.status}
        backdrop={false}
        onClose={(e: any) => {
          props.toggle("");
        }}
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("CHART")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="charts view-charts">
            <Container className="container">
              {chartInfo && Object.keys(chartInfo).length ? (
                <Content>
                  <Form layout="inline">
                    <div className="view-usr-profile text-center mb-2">
                      <div>
                        <img
                          src={
                            chartInfo && chartInfo?.chart_image_url
                              ? chartInfo.chart_image_url
                              : UtilityServices.getLoggedInUser(
                                  "chart_default_image"
                                )
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <Form.Group controlId="name">
                      <Form.ControlLabel>{t("NAME")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${chartInfo?.chart_title}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="license">
                      <Form.ControlLabel>{t("LICENSE")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${chartInfo?.license?.license_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="total_songs">
                      <Form.ControlLabel>
                        {t("TOTAL")} {t("SONGS")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${chartInfo?.total_songs}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="max_songs">
                      <Form.ControlLabel>
                        {t("MAX")} {t("SONGS")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${chartInfo?.max_songs}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="company">
                      <Form.ControlLabel>{t("COMPANY")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${chartInfo?.company?.comp_name}`)}{" "}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="store_group">
                      <Form.ControlLabel>
                        {t("STORE")} {t("GROUP")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${chartInfo?.store_group?.group_name}`)}{" "}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="chart_type">
                      <Form.ControlLabel>
                        {t("CHART")} {t("TYPE")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${chartInfo?.chart_type}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    {chartInfo?.chart_type == "event" && (
                      <Form.Group controlId="event">
                        <Form.ControlLabel>{t("EVENT")}</Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${chartInfo?.event?.event_name}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                    )}
                    <Form.Group controlId="chart_for">
                      <Form.ControlLabel>
                        {t("CHART")} {t("FOR")}{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${chartInfo?.chart_for}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="for_all_company">
                      <Form.ControlLabel>
                        {t("FOR")} {t("ALL")} {t("COMPANY")}{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {chartInfo?.for_all_company == "1" ? t("YES") : t("NO")}
                      </Form.ControlLabel>
                    </Form.Group>
                    {chartInfo?.chart_for == "public" && (
                      <Form.Group controlId="for_company_type_name">
                        <Form.ControlLabel>
                          {t("COMPANY")} {t("TYPE")}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${chartInfo?.for_company_type_name}`)}{" "}
                        </Form.ControlLabel>
                      </Form.Group>
                    )}
                    <Form.Group controlId="availability">
                      <Form.ControlLabel>
                        {t("AVAILABILITY")}{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {chartInfo?.availability}
                      </Form.ControlLabel>
                    </Form.Group>

                    {chartInfo?.availability == "on-date" && (
                      <Form.Group controlId="availability_date">
                        <Form.ControlLabel>
                          {t("AVAILABILITY")} {t("DATE")}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {t("FROM")}{" "}
                          {displayDateField(`${chartInfo?.start_date}`)}{" "}
                          {t("TO")} {displayDateField(`${chartInfo?.end_date}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                    )}
                  </Form>
                </Content>
              ) : null}
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewProfileModal;
